export const KIOSK_SUGGESTIONS_MODAL_DEFAULT_BUTTON_LABEL =
  'kiosk-suggestions-modal.continue-button';

export function resolveKioskSuggestionsModalButtonLabel(label?: string | null): string {
  const trimmed = label?.trim() ?? '';
  return trimmed.length > 0 ? trimmed : KIOSK_SUGGESTIONS_MODAL_DEFAULT_BUTTON_LABEL;
}
